import { Route, Routes } from 'react-router-dom';
import JobDetailsPage from 'pages/jobs/JobDetailsPage';
import JobEditPage from 'pages/jobs/JobEditPage';
import JobCreatePage from 'pages/jobs/JobCreatePage';
import RuleDetailsPage from 'pages/rules/RuleDetailsPage';
import RuleEditPage from 'pages/rules/RuleEditPage';
import RuleCreatePage from 'pages/rules/RuleCreatePage';
import VariableDetailsPage from 'pages/variables/VariableDetailsPage';
import VariableEditPage from 'pages/variables/VariableEditPage';
import VariableCreatePage from 'pages/variables/VariableCreatePage';
import DataCertificationListPage from 'pages/data-certifications/DataCertificationListPage';
import GroupDetailsPage from 'pages/groups/GroupDetailsPage';
import GroupEditPage from 'pages/groups/GroupEditPage';
import GroupCreatePage from 'pages/groups/GroupCreatePage';
import AuthorizationProtected from '../components/authorization-protected';
import { UserOperations, UserRole } from '../types/user';
import { CREATE_JOB, COPY_JOB, CREATE_RULE, CREATE_VARIABLE, EDIT_JOB, EDIT_RULE, EDIT_VARIABLE, JOB, RULE, VARIABLE, GROUP, CREATE_GROUP, EDIT_GROUP, DATA_CERTIFICATIONS } from './links';
import JobCopyPage from 'pages/jobs/JobCopyPage';

function MainAdminPageNavigator(): JSX.Element {
  return (
    <Routes>
      <Route
        path={CREATE_JOB}
        element={
          <AuthorizationProtected requiredOperations={[UserOperations.JOB_CREATE]}>
            <JobCreatePage />
          </AuthorizationProtected>
        }
      />
      <Route
        path={CREATE_RULE}
        element={
          <AuthorizationProtected requiredOperations={[UserOperations.RULE_CREATE]}>
            <RuleCreatePage />
          </AuthorizationProtected>
        }
      />
      <Route
        path={CREATE_VARIABLE}
        element={
          <AuthorizationProtected requiredOperations={[UserOperations.VARIABLE_CREATE]}>
            <VariableCreatePage />
          </AuthorizationProtected>
        }
      />
      <Route
        path={CREATE_GROUP}
        element={
          <AuthorizationProtected requiredOperations={[UserOperations.GROUP_CREATE]}>
            <GroupCreatePage />
          </AuthorizationProtected>
        }
      />
      <Route path={JOB} element={<JobDetailsPage />} />
      <Route
        path={EDIT_JOB}
        element={
          <AuthorizationProtected requiredOperations={[UserOperations.JOB_EDIT]}>
            <JobEditPage />
          </AuthorizationProtected>
        }
      />
      <Route
        path={COPY_JOB}
        element={
          <AuthorizationProtected requiredOperations={[UserOperations.JOB_CREATE]}>
            <JobCopyPage />
          </AuthorizationProtected>
        }
      />
      <Route path={RULE} element={<RuleDetailsPage />} />
      <Route path={VARIABLE} element={<VariableDetailsPage />} />
      <Route path={GROUP} element={<GroupDetailsPage />} />
      <Route
        path={EDIT_RULE}
        element={
          <AuthorizationProtected requiredOperations={[UserOperations.RULE_EDIT]}>
            <RuleEditPage />
          </AuthorizationProtected>
        }
      />
      <Route
        path={EDIT_GROUP}
        element={
          <AuthorizationProtected requiredOperations={[UserOperations.GROUP_EDIT]}>
            <GroupEditPage />
          </AuthorizationProtected>
        }
      />
      <Route
        path={EDIT_VARIABLE}
        element={
          <AuthorizationProtected requiredOperations={[UserOperations.VARIABLE_EDIT]}>
            <VariableEditPage />
          </AuthorizationProtected>
        }
      />
      <Route
        path={DATA_CERTIFICATIONS}
        element={
          <AuthorizationProtected requiredRole={UserRole.VALIDATION_PORTAL_ADMIN}>
            <DataCertificationListPage />
          </AuthorizationProtected>
        }
      />
      <Route path='*' element={<></>} />
    </Routes>
  );
}

export default MainAdminPageNavigator;
